// src/Pages/MyAccount.js
import React from "react";
import { useAuth } from "../auth/AuthContext";
import { useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";

export default function MyAccount() {
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  if (!currentUser) {
    return (
      <main style={container}>
        <h2>Please log in</h2>
        <button style={btnDark} onClick={() => navigate("/login")}>
          Login
        </button>
      </main>
    );
  }

  return (
    <main style={container}>
      <h1 style={{ marginBottom: "10px" }}>My Account</h1>
      <p style={{ color: "#666", marginBottom: 30 }}>
        Logged in as: <strong>{currentUser.email}</strong>
      </p>

      <button style={btnLight} onClick={() => navigate("/my-orders")}>
        My Orders
      </button>

      <button style={btnLight} onClick={() => navigate("/edit-account")}>
        Edit Details
      </button>

      <button
        style={{ ...btnDark, marginTop: 30 }}
        onClick={async () => {
          await signOut(auth);
          navigate("/");
        }}
      >
        Logout
      </button>
    </main>
  );
}

const container = {
  maxWidth: 500,
  margin: "0 auto",
  padding: "40px 20px",
  textAlign: "center",
};

const btnLight = {
  width: "100%",
  padding: "12px",
  margin: "10px 0",
  borderRadius: "8px",
  border: "1px solid #444",
  background: "#fff",
  color: "#111",
  fontSize: "15px",
  cursor: "pointer",
};

const btnDark = {
  width: "100%",
  padding: "12px",
  margin: "10px 0",
  borderRadius: "8px",
  background: "#111",
  color: "#fff",
  fontSize: "15px",
  cursor: "pointer",
};
